import React, { FC, useEffect, useState, useCallback, useRef } from "react";

import { AxiosError } from "axios";
import { Button, Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExport } from "@fortawesome/free-solid-svg-icons";
import useSpinnerLoader from "../../../../shared/components/spinner-loader";
import TableHeaderOrdering, {
  Header,
  OrderData,
} from "../../../../shared/components/table-header-ordering";
import { notificationService } from "../../../../shared/services/notification-service";
import TableRowNoData from "../../../../shared/components/molecules/commons/table-row-no-data";
import { HrOnlineService } from "../../../../shared/services/Report/HrOnline/hr-online";
import {
  Document,
  Page,
  View,
  Text,
  PDFDownloadLink,
  Font,
  StyleSheet,
} from "@react-pdf/renderer";

import moment from "moment";
// Type definition for PDFDownloadLink render function
Font.register({
  family: "kanit-regular",
  src: "https://fonts.gstatic.com/s/kanit/v1/L6VKvM17ZmevDynOiw7H9w.ttf",
});
Font.register({
  family: "kanit-200",
  src: "https://fonts.gstatic.com/s/kanit/v1/wfLWkj1C4tYl7MoiFWS3bA.ttf",
});

const zw = "\u200B";
interface PDFDownloadLinkRenderProps {
  blob: Blob | null;
  url: string | null;
  loading: boolean;
  error: Error | null;
}

// ลงทะเบียนฟอนต์ kanit-200
Font.register({
  family: "kanit-200",
  src: "data:font/truetype;base64,AAEAAAATAQAABAAwRkZUTYYwf2YAAIdQAAAAHEdERUYAJwBmAACHMAAAAB5PUy8yVrxJ2AAAAVgAAABgY21hcAB9wSoAAAHIAAABSmN2dCAHYBmwAAAPyAAAACpmcGdtD7QvpwAADCQAAAJlZ2FzcAAAABAAAAcoAAAACGdseWYl3vHlAAAQkAAAYRxoZWFkAp1o3AAAAT4AAAA2aGhlYQfeA3EAAAFsAAAAJGhtdHgHKATGAAAB8AAAAYpsb2NhPldWLAAAEBwAAADObWF4cAIkAK0AAAG8AAAAIG5hbWUzIkcqAACRfAAAAf5wb3N0AAMAAAACS0AAAAgAAQAAAAEAAHFVy0pfDzz1AB8D6AAAAADUvX8JAAAAANS9fwkAAP8gA+gDYwAAAAgAAgAAAAAAAAABAAADYP8gAFwD6AAAAAAGsQABAAAAAAAAAAAAAAAAAAAAGQABAAAAGQBPAAcAAAAAAAIAAAABAAEAAABAAAAAAAAAAAEDYAGQAAUACAKZAswAAACPApkCzAAAAesAMwEJAAACAAUDAAAAAAAAAAAAAQAAAAAAAAAAAAAAAFBmRWQAQAAh4AYDYAAAAFwDYADgAAAAAQAAAAAAAAPoAAAD6AAAA+gAAAPoAAAD6AAAA+gAAAPoAAAD6AAAA+gAAAPoAAAD6AAAA+gAAAPoAAAD6AAAA+gAAAPoAAAD6AAAA+gAAAPoAAAD6AAAA+gAAAPoAAAD6AAAA+gAAAPoAAAD6AAAA+gAAAPoAAAAAAMAAAADAAAAHAABAAAAAABEAAMAAQAAABwABAAoAAAABgAEAAEAAgAh4Ab//wAAACHgAP///+EgAQABAAAAAAAAAAABBgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAIgAAATICqgADAAcAKUAmAAAAAwIAA1cAAgEBAksAAgIBTwQBAQIBQwAABwYFBAADAAMRBQ8rMxEhESczESMiARDuzMwCqv1WIgJmAAAABQAs/+EDvAMYABYAMAA6AFIAXgF3S7ATUFhASgIBAA0ODQAOZgADDgEOA14AAQgIAVwQAQkICgYJXhEBDAYEBgxeAAsEC2kPAQgABgwIBlgACgcFAgQLCgRZAA4ODVEADQ0KDkIbS7AXUFhATAIBAA0ODQAOZgADDgEOA14AAQgIAVwQAQkICgoJXhEBDAYEBgxeAAsEC2kPAQgABgwIBlgACgcFAgQLCgRZAA4ODVEADQ0KDkIbS7AYUFhATQIBAA0ODQAOZgADDgEOA14AAQgIAVwQAQkICgoJXhEBDAYEBgxeAAsEC2kPAQgABgwIBlgACgcFAgQLCgRYAA4NDQ5RAA4ODU8ADQ4NQxtATgIBAA0ODQAOZgADDgEOAwFmAAEICAFcEAEJCAoICQpmEQEMBgQGDAR", // Base64 encoded font data here
});

// Define styles
const styles = StyleSheet.create({
  page: {
    padding: 20,
    fontFamily: "kanit-200",
  },
  header: {
    fontSize: 16,
    textAlign: "center",
    marginBottom: 3,
  },
  subHeader: {
    fontSize: 14,
    textAlign: "center",
    marginBottom: 10,
  },
  table: {
    display: "flex",
    width: "auto",
    borderStyle: "solid",
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
  },
  tableRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
  },
  tableCol: {
    width: "25%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  tableCell: {
    fontSize: 12,
    padding: 5,
  },
});

const thaiMonths = [
  "มกราคม",
  "กุมภาพันธ์",
  "มีนาคม",
  "เมษายน",
  "พฤษภาคม",
  "มิถุนายน",
  "กรกฎาคม",
  "สิงหาคม",
  "กันยายน",
  "ตุลาคม",
  "พฤศจิกายน",
  "ธันวาคม",
];

const ReportManpowerFrameworkOverviewListPage: FC = () => {
  const [queryParams, setQueryParams] = useState<any>({
    ordering_field: "",
    ordering: "",
    page: 1,
    page_size: 10,
    year: moment().year() + 543,
  });
  const [data, setData] = useState<any>([]);
  const [dataExport, setDataExport] = useState<any>([]);
  const { loaderComponent, startLoading, stopLoading } = useSpinnerLoader();
  const loadingRef = useRef({ startLoading, stopLoading });
  loadingRef.current = { startLoading, stopLoading };

  const headers: Header[] = [
    {
      label: "พนักงาน",
      field: "type",
      order: null,
      isOrder: true,
    },
    {
      label: "กรอบ",
      field: "total_power_rate",
      order: null,
      isOrder: true,
    },
    {
      label: "บรรจุจริง",
      field: "actual_filled",
      order: null,
      isOrder: true,
    },
    {
      label: "คิดเป็นร้อยละของพนักงานทั้งหมด",
      field: "vacant_positions",
      order: null,
      isOrder: true,
    },
  ];

  const fetchData = useCallback(
    async (params: any) => {
      loadingRef.current.startLoading();
      try {
        const result =
          await HrOnlineService.getReportManpowerFrameworkOverviewList(params);
        setData(result);
        setDataExport(result);
      } catch (error) {
        const err = error as AxiosError;
        notificationService.dangerNotification(
          "โหลดข้อมูลไม่สำเร็จ",
          err.message
        );
      } finally {
        loadingRef.current.stopLoading();
      }
    },
    [queryParams.ordering_field, queryParams.ordering]
  );

  const tableRowNoData = () => {
    if (data.rows?.employee?.length === 0) {
      return <TableRowNoData colspan={7} />;
    }
    return null;
  };

  const PDF: React.FC<{ data: any }> = ({ data }) => (
    <Document>
      <Page size="A4" style={{ padding: 20, fontFamily: "kanit-regular" }}>
        <View>
          {/* หัวรายงาน */}
          <View style={{ marginBottom: 20 }}>
            <Text
              style={{
                fontSize: 16,
                textAlign: "center",
                marginBottom: 1,
                fontFamily: "kanit-regular",
              }}
            >
              {"องค์การตลาดเพื่อเกษตรกร"+ zw}
            </Text>

            <Text
              style={{
                fontSize: 16,
                textAlign: "center",
                marginBottom: 1,
                fontFamily: "kanit-regular",
              }}
            >
              {"รายงานแสดงภาพรวมกรอบอัตรากำลัง"+ zw}
            </Text>

            <Text
              style={{
                fontSize: 16,
                textAlign: "center",
                marginBottom: 1,
                fontFamily: "kanit-regular",
              }}
            >
              {"ประจำวันที่"+ zw}{" "}
              {moment().format("D") +
                " " +
                thaiMonths[moment().month()] +
                " " +
                (moment().year() + 543)}
            </Text>
          </View>

          {/* ตาราง - ครอบทั้งตารางด้วย View เดียว */}
          <View
            style={{
              border: "1px solid black",
            }}
          >
            {/* หัวตาราง */}
            <View
              style={{
                flexDirection: "row",
                borderBottom: "1px solid black",
                fontFamily: "kanit-regular",
                fontSize: 11,
              }}
              fixed
            >
              <Text
                style={{
                  width: "30%",
                  textAlign: "center",
                  padding: 5,
                  borderRight: "1px solid black",
                }}
              >
                {"พนักงาน"+ zw}
              </Text>
              <Text
                style={{
                  width: "20%",
                  fontSize: 11,
                  textAlign: "center",
                  padding: 5,
                  borderRight: "1px solid black",
                }}
              >
                {"กรอบ"+ zw}
              </Text>
              <Text
                style={{
                  width: "20%",
                  textAlign: "center",
                  padding: 5,
                  borderRight: "1px solid black",
                }}
              >
                {"บรรจุจริง"+ zw}
              </Text>
              <Text
                style={{
                  width: "30%",
                  textAlign: "center",
                  padding: 5,
                }}
              >
                {"คิดเป็นร้อยละของพนักงานทั้งหมด"+ zw}
              </Text>
            </View>
            {/* ข้อมูลผู้บริหาร */}
            {data.rows?.manager?.map((item: any, index: any) => (
              <View
                key={index}
                style={{
                  flexDirection: "row",
                  borderBottom: "1px solid black",
                  fontFamily: "kanit-200",
                  fontSize: 10,
                }}
              >
                <Text
                  style={{
                    width: "30%",
                    textAlign: "left",
                    padding: 5,
                    borderRight: "1px solid black",
                  }}
                >
                  {"ผู้บริหาร(ระดับ 10-8)"+ zw}
                </Text>
                <Text
                  style={{
                    width: "20%",
                    textAlign: "center",
                    padding: 5,
                    borderRight: "1px solid black",
                  }}
                >
                  {item.total_power_rate}
                </Text>
                <Text
                  style={{
                    width: "20%",
                    textAlign: "center",
                    padding: 5,
                    borderRight: "1px solid black",
                  }}
                >
                  {item.actual_filled}
                </Text>
                <Text
                  style={{
                    width: "30%",
                    textAlign: "center",
                    padding: 5,
                  }}
                >
                  {item.percentage}
                </Text>
              </View>
            ))}
            {/* ข้อมูลพนักงาน */}
            {data.rows?.employee?.map((item: any, index: any) => (
              <View
                key={index}
                style={{
                  flexDirection: "row",
                  borderBottom: "1px solid black",
                  fontFamily: "kanit-200",
                  fontSize: 10,
                }}
              >
                <Text
                  style={{
                    width: "30%",
                    textAlign: "left",
                    padding: 5,
                    borderRight: "1px solid black",
                  }}
                >
                  {"พนักงานระดับปฎิบัติการ(ระดับ 7-4)"+ zw}
                </Text>
                <Text
                  style={{
                    width: "20%",
                    textAlign: "center",
                    padding: 5,
                    borderRight: "1px solid black",
                  }}
                >
                  {item.total_power_rate}
                </Text>
                <Text
                  style={{
                    width: "20%",
                    textAlign: "center",
                    padding: 5,
                    borderRight: "1px solid black",
                  }}
                >
                  {item.actual_filled}
                </Text>
                <Text
                  style={{
                    width: "30%",
                    textAlign: "center",
                    padding: 5,
                  }}
                >
                  {item.percentage}
                </Text>
              </View>
            ))}

            {/* ลูกจ้างประจำ */}
            {data.rows?.permanent?.map((item: any, index: any) => (
              <View
                key={index}
                style={{
                  flexDirection: "row",
                  fontFamily: "kanit-200",
                  fontSize: 10,
                }}
              >
                <Text
                  style={{
                    width: "30%",
                    textAlign: "left",
                    padding: 5,
                    borderRight: "1px solid black",
                  }}
                >
                  {"ลูกจ้างประจำชั้น (ชั้น 2 และ ชั้น 1)"+ zw}
                </Text>
                <Text
                  style={{
                    width: "20%",
                    textAlign: "center",
                    padding: 5,
                    borderRight: "1px solid black",
                  }}
                >
                  {item.total_power_rate}
                </Text>
                <Text
                  style={{
                    width: "20%",
                    textAlign: "center",
                    padding: 5,
                    borderRight: "1px solid black",
                  }}
                >
                  {item.actual_filled}
                </Text>
                <Text
                  style={{
                    width: "30%",
                    textAlign: "center",
                    padding: 5,
                  }}
                >
                  {item.percentage}
                </Text>
              </View>
            ))}

            {/* ลูกจ้างชั่วคราว */}
            {data.rows?.temporary?.map((item: any, index: any) => (
              <View
                key={index}
                style={{
                  flexDirection: "row",
                  borderBottom: "1px solid black",
                  fontFamily: "kanit-200",
                  fontSize: 10,
                }}
              >
                <Text
                  style={{
                    width: "30%",
                    textAlign: "left",
                    padding: 5,
                    borderRight: "1px solid black",
                  }}
                >
                  {"ลูกจ้างชั่วคราว"+ zw}
                </Text>
                <Text
                  style={{
                    width: "20%",
                    textAlign: "center",
                    padding: 5,
                    borderRight: "1px solid black",
                  }}
                >
                  {item.total_power_rate}
                </Text>
                <Text
                  style={{
                    width: "20%",
                    textAlign: "center",
                    padding: 5,
                    borderRight: "1px solid black",
                  }}
                >
                  {item.actual_filled}
                </Text>
                <Text
                  style={{
                    width: "30%",
                    textAlign: "center",
                    padding: 5,
                  }}
                >
                  {item.percentage}
                </Text>
              </View>
            ))}

            {/* รวม */}
            {data.rows?.total_all?.map((item: any, index: any) => (
              <View
                key={index}
                style={{
                  flexDirection: "row",
                  borderTop: "1px solid black",
                  fontFamily: "kanit-regular",
                  fontSize: 10,
                }}
              >
                <Text
                  style={{
                    textAlign: "center",
                    width: "30%",
                    padding: 5,
                    fontWeight: "bold",
                    borderRight: "1px solid black",
                  }}
                >
                  {"รวม"+ zw}
                </Text>
                <Text
                  style={{
                    textAlign: "center",
                    width: "20%",
                    padding: 5,
                    fontWeight: "bold",
                    borderRight: "1px solid black",
                  }}
                >
                  {item.total_power_rate}
                </Text>
                <Text
                  style={{
                    textAlign: "center",
                    width: "20%",
                    padding: 5,
                    borderRight: "1px solid black",
                  }}
                >
                  {item.actual_filled}
                </Text>
                <Text
                  style={{
                    textAlign: "center",
                    width: "30%",
                    padding: 5,
                    fontWeight: "bold",
                  }}
                >
                  {item.percentage}
                </Text>
              </View>
            ))}
          </View>
        </View>
      </Page>
    </Document>
  );

  useEffect(() => {
    fetchData(queryParams);
  }, [fetchData]);

  return (
    <>
      <div className="d-flex justify-content-between py-4">
        <h2 className="text-mof-primary m-0">
        รายงานแสดงภาพรวมกรอบอัตรากำลัง
        </h2>
      </div>
      {loaderComponent}
      <div className="row">
        {/* <label className="form-label">ปี</label>
        <div className="col-sm-12 col-md-2">
          <input
            className="form-control"
            type="text"
            value={queryParams.year ? queryParams.year : ""}
            onChange={handleYearChange}
            name="search"
          />
        </div>
        <div className="col-sm-12 col-md-4">
          <Button
            variant="primary"
            type="button"
            className="d-inline-block px-4"
            onClick={() => fetchData(queryParams)}
          >
            <FontAwesomeIcon icon={faSearch}></FontAwesomeIcon>
          </Button>
        </div> */}
        <div className="col-sm-12 col-md-12 d-flex justify-content-end">
          <PDFDownloadLink
            document={<PDF data={dataExport} />}
            fileName={`รายงานแบ่งประเภท : สรุปแนวโน้มการเกษียณอายุของตำแหน่ง เป้าหมายในอีก 3 ปี ข้างหน้า.pdf`}
          >
            {
              (({ loading }: any) => (
                <Button
                  variant="primary"
                  className="btn-action btn-mof-primary me-2"
                  disabled={loading}
                >
                  <FontAwesomeIcon icon={faFileExport} className="me-2" />
                  {loading ? "Loading..." : "Export"}
                </Button>
              )) as any
            }
          </PDFDownloadLink>
        </div>
      </div>

      <div className="overflow-auto mt-3">
        <Table striped bordered hover>
          <thead>
            <TableHeaderOrdering
              headers={headers}
              onChangeOrder={(orderData: OrderData) => {
                setQueryParams({
                  ...queryParams,
                  ordering_field: orderData.field,
                  ordering: orderData.order,
                });
              }}
              isShow={true}
            />
          </thead>
          <tbody>
            {data.rows?.manager?.map((data: any, index: any) => {
              return (
                <ReportManpowerFrameworkOverviewRow
                  key={index}
                  {...data}
                  index={index + 1}
                  type="ผู้บริหาร (ระดับ 10-8)"
                />
              );
            })}
            {data.rows?.employee?.map((data: any, index: any) => {
              return (
                <ReportManpowerFrameworkOverviewRow
                  key={index}
                  {...data}
                  index={index + 1}
                  type="พนักงานระดับปฎิบัติการ (ระดับ 7-4)"
                />
              );
            })}
            {data.rows?.permanent?.map((data: any, index: any) => {
              return (
                <ReportManpowerFrameworkOverviewRow
                  key={index}
                  {...data}
                  index={index + 1}
                  type="ลูกจ้างประจำชั้น (ชั้น 2 และ ชั้น 1)"
                />
              );
            })}
            {data.rows?.temporary?.map((data: any, index: any) => {
              return (
                <ReportManpowerFrameworkOverviewRow
                  key={index}
                  {...data}
                  index={index + 1}
                  type="ลูกจ้างชั่วคราว"
                />
              );
            })}

            {data.rows?.total_all?.map((data: any, index: any) => {
              return (
                <ReportManpowerFrameworkOverviewRow
                  key={index}
                  {...data}
                  index={index + 1}
                  type="รวม"
                  bold={true}
                />
              );
            })}
            {tableRowNoData()}
          </tbody>
        </Table>
      </div>
    </>
  );
};

const ReportManpowerFrameworkOverviewRow: FC<any> = ({
  total_power_rate,
  actual_filled,
  percentage,
  type = null,
  bold = false,
}) => {
  return (
    <tr style={{ fontWeight: bold ? "bold" : "normal" }}>
      <td>{type}</td>
      <td>{total_power_rate}</td>
      <td>{actual_filled}</td>
      <td>{percentage}</td>
    </tr>
  );
};

export default ReportManpowerFrameworkOverviewListPage;
